var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "263cb14e48f4308cea1a3ecee264f0f3.png",
    width: 480,
    height: 480
});